var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "authentication-dialog",
      attrs: {
        visible: _vm.isShow,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        "show-close": true,
        top: "middle",
        area: 480,
        "before-close": _vm.handleBeforeClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-box-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v(_vm._s(_vm.$t("HPP-web_security_authentication_button_title")))]
      ),
      _c(
        "div",
        { staticClass: "authentication-container" },
        [
          _c(
            "div",
            {
              staticClass: "title-email",
              attrs: { title: _vm.maskEmail(_vm.email) },
            },
            [_vm._v(_vm._s(_vm.maskEmail(_vm.email)))]
          ),
          _c("div", { staticClass: "title-message" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.needTrustFlag
                    ? _vm.$t("HPP-web_security_authentication_dialog_msg")
                    : _vm.$t("HPP-web_security_authentication_dialog_2_msg")
                ) +
                "\n    "
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-position": "top",
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
              on: { validate: _vm.onFormValidate },
            },
            [
              _c(
                "el-form-item",
                {
                  ref: "verifyCodeFormItem",
                  attrs: {
                    prop: "verifyCode",
                    label: _vm.$t("verify_code"),
                    error: _vm.verifyCodeError,
                    required: "",
                  },
                },
                [
                  _c("el-input", {
                    directives: [
                      { name: "input-limit", rawName: "v-input-limit" },
                    ],
                    staticClass: "login-code-input",
                    attrs: {
                      placeholder: _vm.$t("HPP-web_verify_code_input_msg"),
                      maxlength: 6,
                      "data-input-type": "ten",
                    },
                    nativeOn: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onConfirm.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.form.verifyCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "verifyCode",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.verifyCode",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.loading,
                          expression: "!loading",
                        },
                      ],
                      staticClass: "send-button",
                      attrs: {
                        disabled: _vm.sendBtn.disabled,
                        type: "default",
                        title: _vm.sendBtn.text || _vm.$t("resend"),
                      },
                      on: {
                        click: () => {
                          _vm.sendNum++
                          _vm.resetverifyCode()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.sendBtn.text || _vm.$t("resend")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c("el-load-icon", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticStyle: { "margin-left": "20px" },
                  }),
                ],
                1
              ),
              _vm.verifyCodeValid && !_vm.loading
                ? _c("span", { staticStyle: { display: "flex", gap: "4px" } }, [
                    _c("i", { staticClass: "icomoon-success_hot" }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("HPP-web_verify_code_already_send_msg")) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm.needTrustFlag
            ? _c(
                "el-checkbox",
                {
                  staticClass: "trust-device",
                  model: {
                    value: _vm.trustChecked,
                    callback: function ($$v) {
                      _vm.trustChecked = $$v
                    },
                    expression: "trustChecked",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("HPP-web_trust_device_checkbox_msg")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.sendExceed
            ? _c("div", { staticClass: "emial-support" }, [
                _vm._v(_vm._s(_vm.$t("HPP-web_verify_code_multi_times_msg"))),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "vertical-align": "bottom" },
              attrs: { type: "primary", disabled: _vm.confirmDisable },
              on: { click: _vm.onConfirm },
            },
            [
              _vm.confirmLoading
                ? [_c("el-load-icon", { staticStyle: { top: "3px" } })]
                : [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("confirm")) + "\n      "
                    ),
                  ],
            ],
            2
          ),
          _c("el-button", { on: { click: _vm.handleBeforeClose } }, [
            _vm._v(_vm._s(_vm.$t("cancel"))),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }